import Lenis from "@studio-freight/lenis";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

window.isMobile = window.innerWidth < 700;
window.mapSliderOverview = null;
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

const initLenis = () => {
  const isMobileScroll = window.matchMedia("(max-width: 860px)").matches;

  if (isMobileScroll) {
    window.lenis = null;
    return;
  }

  const lenis = new Lenis({
    duration: 0.9,
    anchors: {
      offset: 100,
      onComplete: () => {
        console.log("scrolled to anchor");
      },
    },
  });

  window.lenis = lenis;
  lenis.on("scroll", () => ScrollTrigger.update());

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });
};

gsap.ticker.lagSmoothing(0);
initLenis();
